<template>
    <div id="mybookroom">
        <Header />
        <div class="box">
            <div class="container">
                <h1>내 서재</h1>
                <div class="menu">
                    <ul>
                        <!-- <li @click="getViewList" :class="[selectedType === 2 ? 'on' : '']"><a href="#">본 작품</a></li> -->
                        <!-- <li @click="getSubscribeList" :class="[selectedType === 0 ? 'on' : '']"><a>구독한 작품</a></li> -->
                        <!-- <li><a href="#">대여한 작품</a></li> -->
                        <li @click="getBuyList" :class="[selectedType === 1 ? 'on' : '']"><a>소장한 작품</a></li>
                    </ul>
                </div>
                <div class="util">
                    <!-- <select>
                        <option>최근 본 순</option>
                        <option>업데이트 순</option>
                    </select> -->
                    <!-- <img src="../assets/images/icon_checkbox_library.svg" alt="체크박스"> -->
                </div>
                <b-row tag="div" cols="4" sm="2" md="4">
                    <b-col tag="div" v-for="(item, index) in mybookList" :key="index" @click="moveDetail(item)">
                        <img src="../assets/images/adult_mark.svg" alt="성인 마크" class="adult_mark" v-if="item.adult === 1">
                        <img :src="siteConfig.cdnUrl + '/KR/bigtitle/' + item.englishName + '.jpg'">
                        <div class="text">
                            <p class="name">{{item.titleName}}</p>
                            <p class="writer">{{item.publisher}}</p>
                            <p class="time" v-html="item.desc"></p>
                        </div>
                        <!-- <div class="m_alarm ring"><img src="../assets/images/mobile/bell_off.svg" alt="알람"></div> -->
                    </b-col>
                </b-row>
                <div class="paging" v-if="totalRecordSize > 0">
                    <a @click="prevPage()"><img src="../assets/images/arrow_left.svg" /></a>
                    <a class="current" v-if="pageList.length <= 0">1</a>
                    <a v-for="(item, index) in pageList" :key="index" :class="{'current' : item === currentPageNo}" @click="movePage(item)">{{item}}</a>
                    <a @click="nextPage()"><img src="../assets/images/arrow_right.svg" /></a>
                </div>
            </div>
        </div>
        <Footer />
        <Login :initIsShowPopup="isShowLoginPopup" @close="close('Login')" />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Login from '@/components/Login.vue'

export default {
    name: 'Home',
    pageCategory: '',
    components: {
        Header,
        Footer,
        Login,
    },
    data() {
        return {
            selectedType: 1,
            currSort: 0,

            mybookList: [],

            currentPageNo: 1,      //현재 페이지 번호
            currentPageSize: 12,    //한번에 불러올 게시물 수
            maxPageCount:10,        //한 화면에 보여질 페이지 수

            listCount: 0,
            pageCount: 0,
            pageNo: 0,
            pageSize: 0,
            totalRecordSize: 0,

            pageList:[],

            isShowLoginPopup: false,
        }
    },
    async created(){
        await this.mixinSiteConfigCheck();

        this.getMybookList();

    },
    methods: {
        changeSelectedType(type){
            if(this.selectedType === type){
                return;
            }else{
                this.selectedType = type;
                this.currentPageNo = 1;

                this.listCount = 0;
                this.pageCount = 0;
                this.pageNo = 0;
                this.pageSize = 0;
                this.totalRecordSize = 0;

                this.pageList = [];
            }
        },
        prevPage(){
            if(this.currentPageNo > 1){
                this.currentPageNo--;
                this.getMybookList();
            }
        },
        nextPage(){
            if(this.currentPageNo < this.pageCount){
                this.currentPageNo++;
                this.getMybookList();
            }
        },
        movePage(no){
            if(this.currentPageNo === no)
                return;

            this.currentPageNo = no;
            this.getMybookList();
        },
        changePage(){
            this.pageList = [];
            if(this.pageCount === 0)
                return;

            var tmpPageNo = this.currentPageNo - 2;
            if(this.currentPageNo + 2 > this.pageCount){
                tmpPageNo--;
            }
            if(this.currentPageNo +1 > this.pageCount){
                tmpPageNo--;
            }
            for(var i=0; i<5 && tmpPageNo <= this.pageCount; ){
                if(tmpPageNo >= 1){
                    this.pageList.push(tmpPageNo);
                    i++;
                }
                tmpPageNo++;   
            }
        },
        getMybookList(){
            if(this.selectedType === 0){
                this.getSubscribeList();
            }
            else if(this.selectedType === 1){
                this.getBuyList();
            }
        },
        getSubscribeList(){ //구독한 작품 리스트
            this.selectedType = 0;
            this.mybookList = [];

            var param = 
            {
                pageNo: this.currentPageNo,
                pageSize: this.currentPageSize,
                sort: this.currSort,
                sign: this.$store.state.sign,
                ticket: this.$store.state.ticket,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
            }
            this.$Axios.post(`${this.host}/subscribe/list`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                // console.log('-----구독한 리스트-----');
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.mybookList = res.data.list;
                    this.listCount       = res.data.page.listCount;
                    this.pageCount       = res.data.page.pageCount;
                    this.pageNo          = res.data.page.pageNo;
                    this.pageSize        = res.data.page.pageSize;
                    this.totalRecordSize = res.data.page.totalRecordSize;
                    this.changePage();
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getBuyList(){   //소장한 작품 리스트
            this.selectedType = 1;
            this.mybookList = [];

            var param = 
            {
                pageNo: this.currentPageNo,
                pageSize: this.currentPageSize,
                sign: this.$store.state.sign,
                ticket: this.$store.state.ticket,
            }
            this.$Axios.post(`${this.host}/member/buy/list`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                // console.log('-----구매 리스트-----');
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.mybookList = res.data.list;
                    this.listCount       = res.data.page.listCount;
                    this.pageCount       = res.data.page.pageCount;
                    this.pageNo          = res.data.page.pageNo;
                    this.pageSize        = res.data.page.pageSize;
                    this.totalRecordSize = res.data.page.totalRecordSize;
                    this.changePage();
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getViewList(){  //본 작품 리스트
            this.selectedType = 2;
            this.mybookList = [];

            var param = 
            {
                pageNo: this.currentPageNo,
                pageSize: this.currentPageSize,
                sort: this.currSort,
                sign: this.$store.state.sign,
                ticket: this.$store.state.ticket,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
            }
            this.$Axios.post(`${this.host}/mylibrary/viwelist`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                // console.log('-----본 작품 리스트-----');
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.mybookList = res.data.list;
                    this.listCount       = res.data.page.listCount;
                    this.pageCount       = res.data.page.pageCount;
                    this.pageNo          = res.data.page.pageNo;
                    this.pageSize        = res.data.page.pageSize;
                    this.totalRecordSize = res.data.page.totalRecordSize;
                    this.changePage();
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        moveDetail(item){
            
            if(item.adult === 1){
                if(this.$store.state.loginCheck === false){
                    this.isShowLoginPopup = true;
                }
                else if(!this.$store.state.adult){
                    var src = this.siteConfig.niceUrl + '?email=' + this.$store.state.email;
                    window.open(src, 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=no, location=no, scrollbar=no');
                }
                else{
                    // this.$router.push('/Toondetail/' + item.englishName);
                    this.$router.push('/Toondetail/' + item.webToonIndex);
                }
            }else{
                // this.$router.push('/Toondetail/' + item.englishName);
                this.$router.push('/Toondetail/' + item.webToonIndex);
            }
            
        },
    }
}
</script>